<div id="maintenance-container">
  @for (message of messages; track $index) {
    <div class="message">
      {{ message }}
    </div>
  }
</div>
